import { noDataFilter } from "app/filters/ngFilters";
import type { FunctionComponent } from "react";
import type { ITableCellProps } from "../interfaces/ITableCellProps";
import { trackEvent } from "../SWReactTableTrackEvent";
import { UpgradeLink } from "./UpgradeLink";

export const SimpleLinkCell: FunctionComponent<ITableCellProps> = ({
    value,
    tableOptions,
    tableMetadata,
    track = trackEvent,
    row,
}) => {
    const { Domain } = row;

    if (Domain === "grid.upgrade") {
        return <UpgradeLink />;
    } else {
        const newValue = noDataFilter()(value, "^\\s*n\\/a\\s*$", "-");

        return (
            <div className="link-cell cell-padding cell-innerText">
                <a
                    className="ad-target-url"
                    href={newValue}
                    onClick={() => {
                        track(tableOptions, "External Link", newValue, "click");
                    }}
                    target="_blank"
                >
                    {newValue.replace(/^https?:\/\//, "")}
                </a>
            </div>
        );
    }
};
